export const REFERRRER_CODE_KEY = 'eeref';

export default {
    REFERRRER_CODE_KEY,
};
